import MSlice from "../../helper/MSlice";

const templateSlice = new MSlice({ name: "template" });

export const templateActions = templateSlice.getActions();

export default templateSlice.getReducer();
